module.exports = __webpack_public_path__ + "img/o1.a269b45d.png";